import React from "react";
import s from "./style.module.scss";
import { Link } from "react-router-dom";
import Scan from "shared/icons/Scan";
import { ROUTES_PATH } from "shared/constants/routesPath";
import { useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";
import Button from "shared/ui/Button";

const Gift: React.FC = () => {
  const { auth_key } = useAppSelector(userSelect);

  return (
    <section className={s.gift}>
      <div className={s.content}>
        <h4>Дарим баллы за визит</h4>

        <Button
          white
          href={auth_key ? ROUTES_PATH.SCAN : ROUTES_PATH.REGISTRATION}
        >
          Подробнее
        </Button>
      </div>

      <Link
        to={auth_key ? ROUTES_PATH.SCAN : ROUTES_PATH.REGISTRATION}
        className={s.scan}
      >
        <Scan />

        <span>Сканировать QR-код</span>
      </Link>
    </section>
  );
};

export default Gift;
